<template lang="pug">
.gestion-social
  i.ap-en-construccion
  .asu-title
    span En construcción
  //- TwoColumnDataPanel(:obj="actividades")
</template>

<script>
export default {
  data: () => ({
    actividades: {
      'Recreación Infantil': '-',
      'Asistencia Médica': '-'
    }
  })
}
</script>

<style lang="stylus" scoped>
@import '~@/styles/map/map-info-scoped'

.gestion-social
  text-align: center
  .asu-title
    justify-content: center
    font-weight: bold
    color: $color_0
    margin: 0 0 $f10px 0
  & >>>
    .mapper
      .flex.key, .flex.value
        font-size: $f17px
  .ap-en-construccion
    font-size: $f110px
    color: $color_0
</style>
